import { createSelector } from '@ngrx/store';

import { createCacheStatusSelector } from '@ps/core-data-access';

import { userSettingsFeature } from './user-settings.feature';
import { DASHBOARD_CACHE_TTL } from './user-settings.constants';

// ---------------------------------------------------------------------------
// Settings + entitlements (auto-generated by createFeature)
// ---------------------------------------------------------------------------

export const selectAllBuyerSettings =
  userSettingsFeature.selectAllBuyerSettings;
export const selectCompanySettings = userSettingsFeature.selectCompanySettings;
export const selectCurrencySettings =
  userSettingsFeature.selectCurrencySettings;
export const selectEntitlements = userSettingsFeature.selectEntitlements;
export const selectLoading = userSettingsFeature.selectLoading;
export const selectError = userSettingsFeature.selectError;

// ---------------------------------------------------------------------------
// Dashboard preferences
// ---------------------------------------------------------------------------

export const selectPreferencesLoading =
  userSettingsFeature.selectPreferencesLoading;
export const selectPreferencesError =
  userSettingsFeature.selectPreferencesError;
export const selectPreferencesCachedAt =
  userSettingsFeature.selectPreferencesCachedAt;

export const selectPreferences = createSelector(
  userSettingsFeature.selectPreferences,
  (preferences) => [...preferences].sort((a, b) => a.order - b.order),
);

export const selectSelectedPreferences = createSelector(
  selectPreferences,
  (preferences) =>
    preferences.filter(({ mobile, desktop }) => mobile || desktop),
);

export const selectDefaultPreferences = createSelector(
  selectPreferences,
  (preferences) => preferences.filter(({ isDefault }) => isDefault),
);

export const selectSelectedDesktopPreferences = createSelector(
  selectSelectedPreferences,
  (preferences) => preferences.filter(({ desktop }) => desktop),
);

export const selectSelectedMobilePreferences = createSelector(
  selectSelectedPreferences,
  (preferences) => preferences.filter(({ mobile }) => mobile),
);

export const selectDashboardCacheStatus = createCacheStatusSelector(
  selectPreferencesCachedAt,
  DASHBOARD_CACHE_TTL,
);

// ---------------------------------------------------------------------------
// Report preferences
// ---------------------------------------------------------------------------

export const selectReportPreferences =
  userSettingsFeature.selectReportPreferences;

export const selectReportPreferencesCachedAt =
  userSettingsFeature.selectReportPreferencesCachedAt;

export const selectOrderedReportPreferences = createSelector(
  selectReportPreferences,
  (preferences) => [...preferences].sort((a, b) => a.order - b.order),
);

// ---------------------------------------------------------------------------
// Billing Rules
// ---------------------------------------------------------------------------

export const selectBillingRuleRecord =
  userSettingsFeature.selectBillingRuleRecord;

export const selectBillingRulesCachedAt =
  userSettingsFeature.selectBillingRulesCachedAt;
